<template>
  <div>
    <el-dialog
      append-to-body
      v-model="showDialog"
      width="500px"
      @close="handleClose"
      destroy-on-close
      class="add-dialog-container"
    >
      <template #header>
        <div flex items-center text-size-20px>
          <span>账号信息</span>
        </div>
      </template>
      <el-form label-width="80px" :model="userInfo" ref="userInfoFormRef" :rules="rules" class="custom-form-align-right custom-form-underline" label-position="left" require-asterisk-position="right">
        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="userInfo.name" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="手机号：">
              <el-input v-model="userInfo.phone" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div flex justify-end>
          <el-button @click="handleClose" style="width: 100px;height: 40px">取消</el-button>
          <el-button type="primary" @click="handleUpdateName" style="width: 100px;height: 40px">保存</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import type { MerchantUserType } from "@/api/login/types/login"
import { ElMessage } from "element-plus"
import { ref } from "vue"
import { updateName } from "@/api/user/worker"
import { useUserStore } from "@/store/modules/user"

const emit = defineEmits(["update:show"])

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
})

const userStore = useUserStore()
const showDialog = ref(props.show)
const userInfo = ref<MerchantUserType>({} as MerchantUserType)

const rules = {
  name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
}

const handleClose = () => {
  showDialog.value = false
  emit("update:show", false)
}

const getUserInfo = () => {
  userInfo.value = JSON.parse(JSON.stringify(userStore.getUserInfo())) as MerchantUserType
}

const handleUpdateName = () => {
  userInfo.value.registerTime = undefined
  updateName(userInfo.value).then((res) => {
    if (res.code === 0 && res.data) {
      ElMessage.success("信息保存成功")
      userStore.setUserInfo(userInfo.value)
      handleClose()
    }
  })
}

getUserInfo()
</script>

<style scoped lang="scss"></style>
